import React from "react";
import { Table } from "antd";
import NoDataPage from "../../NoDataPages/NoDataPage";
import investigationImage from "../../../assets/images/nurseIcons/investigation.svg";
const CollectionsTable = ({ data, pagination, handleTableChange }) => {
  const formatCurrency = (value) => (value ? value.toLocaleString("en-IN") : 0);

  const columns = [
    {
      title: "DATE",
      children: [
        {
          title: "Date",
          dataIndex: "date",
          key: "date",
          //   width: 110,
        },
        {
          title: "Day",
          dataIndex: "day",
          key: "day",
          //   width: 60,
        },
      ],
    },
    {
      title: "IP REVENUE",
      children: [
        {
          title: "UPI",
          dataIndex: "ip_upi",
          key: "ip_upi",
          render: formatCurrency,
        },
        {
          title: "Cash",
          dataIndex: "ip_cash",
          key: "ip_cash",
          render: formatCurrency,
        },
        {
          title: "NEFT",
          dataIndex: "ip_neft",
          key: "ip_neft",
          render: formatCurrency,
        },
        {
          title: "Card",
          dataIndex: "ip_card",
          key: "ip_card",
          render: formatCurrency,
        },
        {
          title: "Others",
          dataIndex: "ip_other",
          key: "ip_other",
          render: formatCurrency,
        },
        {
          title: "Total",
          dataIndex: "ip_total",
          key: "ip_total",
          render: formatCurrency,
        },
      ],
    },
    {
      title: "OP REVENUE",
      children: [
        {
          title: "UPI",
          dataIndex: "op_upi",
          key: "op_upi",
          render: formatCurrency,
        },
        {
          title: "Cash",
          dataIndex: "op_cash",
          key: "op_cash",
          render: formatCurrency,
        },
        {
          title: "NEFT",
          dataIndex: "op_neft",
          key: "op_neft",
          render: formatCurrency,
        },
        {
          title: "Card",
          dataIndex: "op_card",
          key: "op_card",
          render: formatCurrency,
        },
        {
          title: "Others",
          dataIndex: "op_other",
          key: "op_other",
          render: formatCurrency,
        },
        {
          title: "Total",
          dataIndex: "op_total",
          key: "op_total",
          render: formatCurrency,
        },
      ],
    },
    {
      title: "TOTAL REVENUE",
      children: [
        {
          title: "UPI",
          dataIndex: "total_upi",
          key: "total_upi",
          render: formatCurrency,
        },
        {
          title: "Cash",
          dataIndex: "total_cash",
          key: "total_cash",
          render: formatCurrency,
        },
        {
          title: "NEFT",
          dataIndex: "total_neft",
          key: "total_neft",
          render: formatCurrency,
        },
        {
          title: "Card",
          dataIndex: "total_card",
          key: "total_card",
          render: formatCurrency,
        },
        {
          title: "Others",
          dataIndex: "total_other",
          key: "total_other",
          render: formatCurrency,
        },
        {
          title: "Total",
          dataIndex: "all_total",
          key: "all_total",
          render: formatCurrency,
        },
      ],
    },
  ];
  const calculateTotals = (rows = []) => {
    return rows.reduce(
      (acc, row) => {
        acc.ip_upi += row.ip_upi || 0;
        acc.ip_cash += row.ip_cash || 0;
        acc.ip_neft += row.ip_neft || 0;
        acc.ip_card += row.ip_card || 0;
        acc.ip_other += row.ip_other || 0;
        acc.ip_total += row.ip_total || 0;

        acc.op_upi += row.op_upi || 0;
        acc.op_cash += row.op_cash || 0;
        acc.op_neft += row.op_neft || 0;
        acc.op_card += row.op_card || 0;
        acc.op_other += row.op_other || 0;
        acc.op_total += row.op_total || 0;

        acc.total_upi += row.total_upi || 0;
        acc.total_cash += row.total_cash || 0;
        acc.total_neft += row.total_neft || 0;
        acc.total_card += row.total_card || 0;
        acc.total_other += row.total_other || 0;
        acc.grand_total += row.all_total || 0;

        return acc;
      },
      {
        ip_upi: 0,
        ip_cash: 0,
        ip_neft: 0,
        ip_card: 0,
        ip_other: 0,
        ip_total: 0,

        op_upi: 0,
        op_cash: 0,
        op_neft: 0,
        op_card: 0,
        op_other: 0,
        op_total: 0,

        total_upi: 0,
        total_cash: 0,
        total_neft: 0,
        total_card: 0,
        total_other: 0,
        grand_total: 0,
      }
    );
  };
  const totals = calculateTotals(data);

  return (
    <div className="collections-table">
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        bordered
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: false,
          position: ["bottomCenter"],
        }}
        onChange={handleTableChange}
        locale={{
          emptyText: (
            <NoDataPage
              title="No Data found"
              subtitle="Select a report type and date range to view data"
              image={investigationImage}
            />
          ),
        }}
        scroll={{ x: "max-content" }}
        summary={() => (
          <Table.Summary.Row style={{ fontWeight: 600, background: "#fafafa" }}>
            <Table.Summary.Cell colSpan={2}>Total</Table.Summary.Cell>

            {/* IP Totals */}
            <Table.Summary.Cell>
              {formatCurrency(totals.ip_upi)}
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {formatCurrency(totals.ip_cash)}
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {formatCurrency(totals.ip_neft)}
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {formatCurrency(totals.ip_card)}
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {formatCurrency(totals.ip_other)}
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {formatCurrency(totals.ip_total)}
            </Table.Summary.Cell>

            {/* OP Totals */}
            <Table.Summary.Cell>
              {formatCurrency(totals.op_upi)}
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {formatCurrency(totals.op_cash)}
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {formatCurrency(totals.op_neft)}
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {formatCurrency(totals.op_card)}
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {formatCurrency(totals.op_other)}
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {formatCurrency(totals.op_total)}
            </Table.Summary.Cell>

            {/* Grand Totals */}
            <Table.Summary.Cell>
              {formatCurrency(totals.total_upi)}
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {formatCurrency(totals.total_cash)}
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {formatCurrency(totals.total_neft)}
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {formatCurrency(totals.total_card)}
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {formatCurrency(totals.total_other)}
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {formatCurrency(totals.grand_total)}
            </Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
    </div>
  );
};

export default CollectionsTable;
